import cn from 'classnames'
import styles from './NotificationCard.module.scss'

const SubmittedMessage = () => (
  <>
    <img src='/signin/bubble_icon.svg' loading='lazy' alt='icon' className={styles.heartImg} />
    <div className={styles.textWrapper}>
      <h2 className={styles.thankYou}>Thank you!</h2>
      <p className={styles.text}>
        We will notify you as soon as we have puppies matching your
        preferences.
      </p>
    </div>
  </>
)

const NotificationCard = ({ message, isSubmitted, setShowNotificationForm, areEven }) => {
  return (

    <div className={cn(styles.notificationCard, areEven ? styles.pair : styles.noPair)}>
      {isSubmitted
        ? SubmittedMessage()
        : (
          <>
            <h3 className={styles.message}>{message}</h3>
            <button
              onClick={() => setShowNotificationForm(true)}
              className={styles.notificationButton}
            >
              <img src='/form_modal/alert.svg' alt='notification bell' className={styles.notificationImg} />{' '}
              Notify Me
            </button>
          </>
          )}
    </div>
  )
}

export default NotificationCard

//
